import { z } from 'zod';

export const HealthDto = z.object({
  status: z.enum(['ok', 'degraded']),
  version: z.string(),
  uptimeSeconds: z.number().nonnegative(),
  checks: z.object({
    database: z.enum(['up', 'down']),
  }),
});
export type HealthDto = z.infer<typeof HealthDto>;
